import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=b0785742&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0785742')) {
      api.createRecord('b0785742', component.options)
    } else {
      api.reload('b0785742', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=b0785742&", function () {
      api.rerender('b0785742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Z88rdiB0J6i/JS/comp/childrenage.vue"
export default component.exports